import { render, staticRenderFns } from "./Datetime.vue?vue&type=template&id=b83b0a0c&scoped=true"
import script from "./Datetime.vue?vue&type=script&lang=js"
export * from "./Datetime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83b0a0c",
  null
  
)

export default component.exports